"use client";

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import "./index.css";
import WelcomeBanner from "../../components/welcomebanner";
import ProfileInfo from "../../components/profileinfo";
import OrdersWishlist from "../../components/orderwishlist";

import {logoutUser} from "../../redux/slices/authSlice"

import withAuth from "../../hoc/withAuth"; // Import the HOC for authentication

// import AddressSection from "../../components/addresssection";

// import ProfilePage from "../ProfilePage";

const UserProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);

  // Redirect to login if user is not authenticated
  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user, navigate]);

  // Function to handle profile edit
  const handleEditProfile = () => {
   navigate("/profile"); // Navigate to the profile page
  };

 // Function to handle logout
 const handleLogout = () => {
  dispatch(logoutUser()); // Dispatch the logout action
  navigate("/"); // Redirect to the login page after logout
};

  return (
    <div className="user-bg">
      <br />
      <main className="main-content">
        <WelcomeBanner user={user} />

        <div className="profile-grid">
          <div className="profile-left-column">
            <ProfileInfo
              user={user}
              onEditProfile={handleEditProfile}
              onLogout={handleLogout}
            />
            {/* <AddressSection  user={user} /> */}
          </div>

          <div className="profile-right-column">
            <OrdersWishlist />
          </div>
        </div>
      </main>
    </div>
  );
};

export default withAuth(UserProfile); // Wrap the component with the HOC for authentication